export const SPLASH_FADE_ANIMATION = 3;
export const FEED_DETAIL_ANIMATION = 3;
export const SPLASH_LOADING_TIME = 3000;
export const SIGN_UP_MAX_LENGTH = 7;
export const COMMENT_MAX_LENGTH = 100;
export const MISSION_ADD_LENGTH = 20;
export const GOALSHOT_RANDOM_CARD = 11;
export const LIKE_MAX_SHOW = 5;
export const CARD_ANIMATION_TIME = 1.1;
export const CARD_BUTTON_TIME = 1000;
export const AUTO_PLAY_TIME = 3000;
export const GRADIENT_TIME = 1;
export const ALERT_MODAL_POPUP = 0.5;
export const ALERT_MODAL_ICON = 1;
export const BUTTON_CLICK_OFFSET = 1000;
